import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
    component: Home
  },
  {
    path: "/home",
    name: "Home",
    meta: { title: "首页" },
    component: Home
  },
  {
    path: "/vlovemother",
    name: "VloveMother",
    meta: { title: "唯爱妈妈" },
    redirect: "/vlovemother/vlovemother",
    component: () => import("../views/PageContainernoMenu.vue"),
    children: [
      {
        path: "vlovemother",
        name: "VloveMother",
        meta: { title: "唯爱妈妈", keepAlive: true },
        component: () => import("../views/vloveMother/VloveMother.vue")
      },
      {
        path: "detail",
        meta: { title: "detail", keepAlive: false },
        component: () => import("../views/Detail.vue")
      }
    ]
  },
  {
    path: "/welfare",
    name: "Welfare",
    meta: { title: "人人公益" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/welfare/vlovedonation",
    children: [
      {
        path: "vlovedonation",
        name: "VloveDonation",
        meta: { title: "唯爱心", keepAlive: true },
        component: () => import("../views/welfare/VloveDonationNew.vue")
      },
      {
        path: "employeewelfare",
        name: "EmployeeWelfare",
        meta: { title: "员工公益", keepAlive: true },
        component: () => import("../views/welfare/EmployeeWelfare.vue")
      },
      {
        path: "detail",
        meta: { title: "detail", keepAlive: false },
        component: () => import("../views/Detail.vue")
      }
    ]
  },
  {
    path: "/ruralvitalization",
    name: "RuralVitalization",
    meta: { title: "乡村振兴" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/ruralvitalization/vloveworkshop",
    children: [
      {
        path: "agriculture",
        name: "Agriculture",
        meta: { title: "助农", keepAlive: true },
        component: () => import("../views/ruralVitalization/Agriculture.vue")
      },
      {
        path: "education",
        name: "Education",
        meta: { title: "助学", keepAlive: true },
        component: () => import("../views/ruralVitalization/AgricultureXue.vue")
      },
      {
        path: "vloveworkshop",
        name: "VloveWorkshop",
        meta: { title: "唯爱工坊", keepAlive: true },
        component: () => import("../views/ruralVitalization/Workshop.vue")
      },
      {
        path: "detail",
        meta: { title: "detail" },
        component: () => import("../views/Detail.vue")
      }
    ]
  },
  {
    path: "/latesttrends",
    name: "LatestTrends",
    meta: { title: "最新动态" },
    component: () => import("../views/TrendContainer.vue"),
    redirect: "/latesttrends/area",
    children: [
      {
        path: "area",
        name: "Area",
        component: () => import("../views/latestTrends/Trends.vue")
      },
      {
        path: "detail",
        meta: { title: "detail" },
        component: () => import("../views/Detail.vue")
      }
    ]
  },
  {
    path: "/aboutus",
    name: "AboutUs",
    meta: { title: "关于我们" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/aboutus/organizationprofile",
    children: [
      {
        path: "organizationprofile",
        name: "OrganizationProfile",
        meta: { title: "机构简介", keepAlive: true },
        component: () => import("../views/aboutUs/OrganizationProfile.vue")
      },
      {
        path: "partybuild",
        name: "PartyBuild",
        meta: { title: "党建专栏", keepAlive: true },
        component: () => import("../views/aboutUs/PartyBuild.vue")
      },
      {
        path: "infodisclosure",
        name: "InfoDisclosure",
        meta: { title: "组织制度", keepAlive: true },
        component: () => import("../views/aboutUs/FoundationReport.vue")
      },
      {
        path: "foundationreport",
        name: "FoundationReport",
        meta: { title: "基金会年报", keepAlive: true },
        component: () => import("../views/aboutUs/FoundationReport.vue")
      },
      {
        path: "honor",
        name: "Honor",
        meta: { title: "荣誉资质", keepAlive: true },
        component: () => import("../views/aboutUs/Honor.vue")
      },
      {
        path: "contactus",
        name: "ContactUs",
        meta: { title: "联系我们", keepAlive: true },
        component: () => import("../views/aboutUs/ContactUs.vue")
      },
      {
        path: "detail",
        meta: { title: "detail", keepAlive: false },
        component: () => import("../views/Detail.vue")
      }
    ]
  },
  {
    path: "/cooperativepartner",
    name: "CooperativePartner",
    meta: { title: "合作伙伴" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/cooperativepartner/govaffairs",
    children: [
      {
        path: "govaffairs",
        name: "GovAffairs",
        meta: { title: "社会慈善组织", keepAlive: true },
        component: () => import("../views/cooperativePartner/GovAffairs.vue")
      },
      {
        path: "loveorg",
        name: "LoveOrg",
        meta: { title: "爱心组织", keepAlive: true },
        component: () =>
          import("../views/cooperativePartner/GovAffairsLove.vue")
      }
    ]
  },
  {
    path: "/auxiliary",
    name: "Auxiliary",
    meta: { title: "辅助栏目" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/auxiliary/sitemap",
    children: [
      {
        path: "sitemap",
        name: "Sitemap",
        meta: { title: "网站地图", keepAlive: true },
        component: () => import("../views/auxiliary/Sitemap.vue")
      },
      {
        path: "law",
        name: "Law",
        meta: { title: "法律声明", keepAlive: true },
        component: () => import("../views/auxiliary/Law.vue")
      },
      {
        path: "links",
        name: "Links",
        meta: { title: "友情链接", keepAlive: true },
        component: () => import("../views/auxiliary/Links.vue")
      }
    ]
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("../views/Search.vue")
  },
  {
    path: "*",
    name: "404",
    component: () => import("../views/404.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  next();
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default router;
